export default "__VITE_ASSET__QsfvbSCs__"